<div class="maintenance-page">
    <div class="maintenance-container">
      <img src="assets/images/sitelogo.svg" class="logo" alt="TheKredible Logo" />
  
      <h1>We'll Be Back Soon</h1>
      <p>Our site is currently undergoing scheduled maintenance.</p>
      <p>Thank you for your patience. We’re working hard to improve your experience.</p>
  
      <div class="footer">
        <p>— TheKredible Team</p>
        <a href="https://www.thekredible.com" target="_blank">www.thekredible.com</a>
      </div>
    </div>
  </div>
  